import {
  CLEAR_CYPRESS_GROUPED_DATA,
  CLEAR_STATUS_WISE_CYPRESS_GROUPED_DATA,
  DELETE_CYPRESS_GROUPED_TEST,
  FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_FAILED,
  FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_SUCCESS,
  FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_LOADING,
  FETCH_CYPRESS_GROUPED_DATA_FAILED,
  FETCH_CYPRESS_GROUPED_DATA_SUCCESS,
  FETCH_CYPRESS_GROUPED_DATA_LOADING,
  SET_ACTIVE_ACCORDION_ON_TEST_LIST,
  UPDATE_CYPRESS_GROUPED_DATA,
  UPDATE_CYP_SIDEBAR_GROUPED_DATA,
} from '../actionTypeConstants/cypressGroupedTestConstants';

import { DEFAULT_TEST_DATA_API_CALL_LIMIT } from '../../constants/views';
import { deleteObjectById } from '../../utils/utilityFunctions';

const initialState = {
  activeAccordion: null,
  statusCount: {},
  testList: {
    isLoading: false,
    testData: { passed: {}, failed: {}, running: {}, other: {} },
    error: null,
  },
  sidebarTestList: {
    total: 0,
    hasMore: false,
    isLoading: false,
    tests: [],
    error: null,
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_LOADING: {
      return {
        ...state,
        testList: {
          ...state.testList,
          isLoading: true,
        },
      };
    }
    case FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_SUCCESS: {
      const { status, offset } = action.payload;

      const response = action?.result?.data || {};
      const { tests = [], total = 0 } = response || {};
      const hasMore = !(tests.length < DEFAULT_TEST_DATA_API_CALL_LIMIT);

      const additionalData = {};
      if (offset === 0) {
        additionalData['total'] = total;
      }

      const existingTests = state.testList.testData[status]?.tests || [];

      return {
        ...state,
        testList: {
          ...state.testList,
          isLoading: false,
          testData: {
            ...state.testList.testData,
            [status]: {
              tests: [...existingTests, ...tests],
              hasMore,
              pageNumber: offset,
              ...additionalData,
            },
          },
        },
      };
    }
    case FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_FAILED: {
      return {
        ...state,
        testList: {
          ...state.testList,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case SET_ACTIVE_ACCORDION_ON_TEST_LIST: {
      const { activeAccordion, statusCount = {} } = action.payload || {};
      return {
        ...state,
        activeAccordion,
        statusCount,
      };
    }

    case CLEAR_STATUS_WISE_CYPRESS_GROUPED_DATA: {
      return {
        ...state,
        testList: {
          isLoading: false,
          testData: { passed: {}, failed: {}, running: {}, other: {} },
          error: null,
        },
      };
    }

    case FETCH_CYPRESS_GROUPED_DATA_LOADING: {
      return {
        ...state,
        sidebarTestList: {
          ...state.sidebarTestList,
          isLoading: true,
        },
      };
    }
    case FETCH_CYPRESS_GROUPED_DATA_SUCCESS: {
      const { offset } = action.payload || {};
      const response = action?.result?.data || {};
      const { tests = [], total = 0 } = response || {};
      const hasMore = !(tests.length < DEFAULT_TEST_DATA_API_CALL_LIMIT);
      const additionalData = {};
      if (offset === 0) {
        additionalData['total'] = total;
      }

      return {
        ...state,
        sidebarTestList: {
          ...state.sidebarTestList,
          isLoading: false,
          hasMore,
          pageNumber: offset,
          tests:
            offset === 0
              ? [...tests]
              : [...state?.sidebarTestList?.tests, ...tests],
          ...additionalData,
        },
      };
    }
    case FETCH_CYPRESS_GROUPED_DATA_FAILED: {
      if (action.error.message === 'api request cancelled') {
        return {
          ...state,
          sidebarTestList: {
            total: 0,
            hasMore: false,
            isLoading: false,
            tests: [],
            error: null,
          },
        };
      }
      return {
        ...state,
        // Reset test data incase API has been cancelled.
        sidebarTestList: {
          ...state.sidebarTestList,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case UPDATE_CYPRESS_GROUPED_DATA: {
      const updatedTestData = action.payload || {};
      const updatedTestIdList = Object.keys(updatedTestData);

      let testData = state.testList?.testData;
      const statusCount = state.statusCount;

      // remove test id's that came from a prev event (if any) and update the data in correct status category post this step
      Object.keys(testData).forEach((key) => {
        let tests = testData[key]?.tests || [];

        const updatedTests = tests.filter(
          (item) => !updatedTestIdList.includes(item.id)
        );

        testData[key].tests = updatedTests;
      });

      updatedTestIdList.map((id) => {
        const testToAdd = updatedTestData[id];

        const { status = '' } = testToAdd || {};

        const statusToUse = status?.toLowerCase();

        let statusCategory;

        if (
          statusToUse === 'passed' ||
          statusToUse === 'failed' ||
          statusToUse === 'running'
        ) {
          statusCategory = statusToUse;
        } else {
          statusCategory = 'other';
        }

        const testStatusList = testData[statusCategory]?.tests;

        // update only when data is fetched from api for that particular category
        if (
          (testStatusList && testStatusList.length > 0) ||
          !statusCount[statusCategory] ||
          statusCount[statusCategory] === 0
        ) {
          testStatusList.push(testToAdd);
        }

        testData[statusCategory].tests = testStatusList;
      });

      return {
        ...state,
        testList: {
          ...state.testList,
          testData: {
            ...testData,
          },
        },
      };
    }

    case UPDATE_CYP_SIDEBAR_GROUPED_DATA: {
      const updatedTestData = action.payload || {};
      let testList = state.sidebarTestList?.tests;

      const newTestlist = testList.map((test) => {
        if (updatedTestData[test.id]) {
          const _test = { ...test, ...updatedTestData[test.id] };
          delete updatedTestData[test.id];
          return _test;
        }
        return test;
      });

      const newList = [
        ...(Object.values(updatedTestData) || []),
        ...newTestlist,
      ];

      return {
        ...state,
        sidebarTestList: {
          ...state.sidebarTestList,
          tests: newList,
        },
      };
    }

    case CLEAR_CYPRESS_GROUPED_DATA: {
      return {
        ...state,
        sidebarTestList: {
          total: 0,
          hasMore: false,
          isLoading: false,
          tests: [],
          error: null,
        },
      };
    }

    case DELETE_CYPRESS_GROUPED_TEST: {
      return {
        ...state,
        sidebarTestList: {
          ...state.sidebarTestList,
          tests: deleteObjectById(
            state.sidebarTestList.tests,
            'id',
            action.payload
          ),
        },
      };
    }

    default:
      return state;
  }
}
